export default "__VITE_ASSET__D18vCUDS__"